<!-- <script>
	export let name;
</script>

<main>
	<h1>Hello {name}!</h1>
	<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style> -->
<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
<script>
    import Profile from './Profile.svelte';
    import Todos from './Todos.svelte';
    import BGCard from './BGCard.svelte';
    import  LoginForm from './LoginForm.svelte';
    import Theme from "./components/Theme.svelte";
	 import Header from "./components/Header.svelte";
    import { auth } from './firebase';
    import { authState } from 'rxfire/auth';

  import {
    Button,
    Accordion,
     Content,
    Breadcrumb,
    BreadcrumbItem,
    Grid,
    Row,
    Column,
    Tabs,
    TabContent,
    Tab,
    Select,
    SelectItem
  } from "carbon-components-svelte";
   // let theme = "g10";
   // document.documentElement.setAttribute("theme", theme);
  // import Header from "./components/Header.svelte";
  // import Theme from "./components/Theme.svelte";
    let user;
    let err;

    const unsubscribe = authState(auth).subscribe(u => user = u);
    // document.documentElement.setAttribute("theme", theme);

    
	function handleLogin(event) {

		auth.signInWithEmailAndPassword( event.detail.uname, event.detail.pwd)
		  .then((userCredential) => {
		    // Signed in
		    user = userCredential.user;
		    // ...
		  })
		  .catch((error) => {
		    var errorCode = error.code;
		    var errorMessage = error.message;
		    err=errorMessage
		  });
    }

</script>
<div class="bg-gray-300">
<div class=" mx-auto px-6">
<!-- <div class="container mx-auto px-4 space-y-6"> -->
  <div class="bg-white p-10 rounded-lg shadow-md">

    <div>
    	<Profile {...user} />
    	<Button on:click={ () => auth.signOut() }>Logout</Button>
  </div>
{#if user}
  <hr>
  <div>
   	<BGCard />
  </div>
{:else}
	<div>
		<LoginForm on:credentials={handleLogin}/>
		{#if err}
			{err}
		{/if}
	</div>
{/if}
</div>
</div>
</div>